import React, { useContext } from 'react';
import { AppContext } from '../index';
var MapListFilter = function (_a) {
    var filter = _a.filter, onFilterChange = _a.onFilterChange, sortField = _a.sortField, sortDirection = _a.sortDirection, onSortChange = _a.onSortChange;
    var t = useContext(AppContext).t;
    return (React.createElement("div", { className: "map-list-filter" },
        React.createElement("div", { className: 'search' },
            React.createElement("input", { type: "text", placeholder: t('map_list.search_maps'), value: filter, onKeyUp: onFilterChange, onChange: onFilterChange })),
        React.createElement("div", { className: "sort-options" },
            React.createElement("span", { className: "date" },
                t('map_list.filter_by_date'),
                ":"),
            React.createElement("span", { onClick: function () { return onSortChange('created'); }, className: "sort-option" + (sortField === 'created' ? " selected" : "") }, t('map_list.filter_date_created')),
            React.createElement("span", { className: 'splitter' }),
            React.createElement("span", { onClick: function () { return onSortChange('lastModified'); }, style: { marginLeft: '5px' }, className: "sort-option" + (sortField === 'lastModified' ? " selected" : "") }, t('map_list.filter_date_modified')),
            sortField != 'none' && (React.createElement("span", { className: "arrow" }, sortDirection === 'asc' ? '▲' : '▼')))));
};
export default MapListFilter;
